import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import CompletedBookingList from '../../../components/SiteAdmin/CompletedTrips/CompletedBookingList';
import Loader from '../../../components/Common/Loader/Loader';
import getCompletedBookingsQuery from './getCompletedBookings.graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

export class CompletedBooking extends Component {

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { completedTrips, completedTrips: { loading } } = this.props;

        return (
            <Loader type={"page"} show={loading}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageCompletedBooking)}</h1>
                {!loading && <CompletedBookingList completedTrips={completedTrips} loading={loading} />}
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withQuery(getCompletedBookingsQuery, {
        name: 'completedTrips',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(CompletedBooking);
